import {ColumnTypeValidationOptions, ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';

export const SAVED_RESULT_VALIDATION_OPTIONS: ColumnTypeValidationOptions = {
  allowedLeafTypes: [LeafType.TEXT, LeafType.RESULT],
  listType: ColumnTypeValidationFlag.NOT_ALLOWED,
  nullableType: ColumnTypeValidationFlag.NOT_ALLOWED,
  maybeTextType: ColumnTypeValidationFlag.NOT_ALLOWED,
};

export enum SavedToResultsStepConfigVariableNames {
  COLUMN_MAPPING = 'columnMapping',
  SCHEMA_ID = 'schemaId',
}
